import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['walkedIn', 'atcCode']

  connect() {
    this.syncAtcCode()
  }

  syncAtcCode() {
    if (this.walkedInTarget.value === 'Y') {
      this.atcCodeTarget.value = 'WALKEDIN'
      this.atcCodeTarget.readOnly = true
      this.atcCodeTarget.classList.add('bg-gray-100', 'text-gray-500', 'cursor-not-allowed')
    } else {
      if (this.atcCodeTarget.value === 'WALKEDIN') {
        this.atcCodeTarget.value = ''
      }
      this.atcCodeTarget.readOnly = false
      this.atcCodeTarget.classList.remove('bg-gray-100', 'text-gray-500', 'cursor-not-allowed')
    }
  }
}
